export default __webpack_public_path__ + "static/media/quote 1.12c0dc0b.svg";